export default __webpack_public_path__ + "static/media/homework.e7a63e45.svg";